module.exports = __webpack_public_path__ + "static/media/chi-18.a891d0ef.jpg";